<template>
  <div class="home">
    <MyHeader title="market"></MyHeader>
    <div class="left-bar"></div>
    <div class="right-bar"></div>
    <div class="bottom-bar"></div>
    <div class="content">
      <div class="left">
        <ChartBarPlus
          ref="barHighTech"
          title="广东省市场主体基本情况"
          subtitle="广东省市场主体总数"
          @handleLink="handleLink"
        />
      </div>
      <div class="center">
        <TopCountMarket
          ref="TopCount"
          :type="mapCode > 1 ? 'Guangdong' : 'Country'"
          :pointName="mapName"
        ></TopCountMarket>
        <div class="link" @click="toPolicy">"十四五规划"地区制造业分布情况</div>
        <GzMap @mapCode="changeMapCode" @loading="(e) => (loading = e)" :linkParams="linkParams"></GzMap>
      </div>
      <div class="right">
        <ChartMarketRight @handleLink="handleLink" />
        <!-- <ScienceTenchnology
          ref="ScienceTenchnology"
          title="广东省科创企业地市分布情况"
          name="privateTax"
          apiName="getPrivateTax"
          type="multi"
          showLabel
        />
        <div class="right-center">
          <Top100 ref="Top100" />
          <PrivateMigrate
            ref="PrivateMigrate"
            title="广东省民营企业迁移分析"
            name="privateTax"
            type="multi"
            showLabel
          />
        </div>
        <div class="right-center">
          <PrivateEconomy
            ref="PrivateEconomy"
            title="广东省民营经济生产总值变化趋势"
            name="privateTax"
            apiName="getPrivateTax"
            type="multi"
            showLabel
          />
          <FinancialService
            ref="PrivateMigrate"
            title="广东省万企兴万村行动开展情况"
            name="privateTax"
            apiName="getPrivateTax"
            type="multi"
            showLabel
          />
        </div> -->
      </div>
    </div>
    <EleDialog :title="dialogTitle" :visible.sync="showDialog">
      <div class="filter-box" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">
        <ElementSelect
          :val="search.cityName"
          :options="optionCity"
          clearable
          @val="changeVal($event, 'cityName')"
          v-if="!apiName.includes('City')"
          size="middle"
        />
        <ElementSelect
          :val="search.year"
          :options="optionYear"
          clearable
          @val="changeVal($event, 'year')"
          v-else
          size="middle"
        />
        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" />
      </div>
      <ComTable
        :tableCol="tableCol"
        :tableData="tableData"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>

    <!--<div class="loading" v-loading="loading" v-if="loading"-->
    <!--     element-loading-background="rgba(0, 0, 0, 0)">-->
    <!--</div>-->
    <div class="o0"></div>
  </div>
</template>

<script>
import { getTime } from '@/utils';
import router from '@/router';
import GzMap from './comp/GzMap';
import TopCountMarket from './comp/TopCountMarket';
import EconomicEntities from './comp/EconomicEntities';
import PrivateEnterprise from './comp/PrivateEnterprise';
import Top500 from './comp/Top500';
import CompanyTop100 from './comp/CompanyTop100';
import ChartBar from './comp/ChartBar';
import ChartBarPlus from './comp/ChartBarPlus.vue';
import ChartMarketRight from './comp/ChartMarketRight.vue';
import GDPAndGrowthRate from './comp/GDP-and-growth-rate';
import FixedAssetInvestment from './comp/fixed-asset-investment';
import EconomicVolume from './comp/economic-volume';
import PrivateEconomy from './comp/PrivateEconomy.vue';
import FinancialService from './comp/FinancialService.vue';
import ScienceTenchnology from './comp/ScienceTenchnology.vue';
import Top100 from './comp/Top100';
import PrivateMigrate from './comp/PrivateMigrate.vue';
import MarketSubjectType from './comp/MarketSubjectType';
import MarketMainIndustry from './comp/MarketMainIndustry.vue';
import SmallMicroEnterprises from './comp/SmallMicroEnterprises.vue';
import Chart3D from './comp/Chart3D';
import ComTable from '../../components/ComTable';
import ElementSelect from '../../components/element-select';
import cityJson from './cityJson';
import MyHeader from '@/components/Header';

export default {
  name: 'Market',
  components: {
    MyHeader,
    ElementSelect,
    ComTable,
    Chart3D,
    ScienceTenchnology,
    Top100,
    PrivateMigrate,
    PrivateEconomy,
    FinancialService,
    MarketSubjectType,
    MarketMainIndustry,
    SmallMicroEnterprises,
    EconomicVolume,
    FixedAssetInvestment,
    GDPAndGrowthRate,
    ChartBar,
    ChartBarPlus,
    ChartMarketRight,
    CompanyTop100,
    Top500,
    PrivateEnterprise,
    EconomicEntities,
    TopCountMarket,
    GzMap,
  },
  data() {
    return {
      linkParams: {
        dataType: 1,
        year: 2024,
      },
      isLogin: true,
      pass: '',
      // currentTime: getTime(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      timer: null,
      mapCode: 1,
      mapName: '',
      loading: true,
      showDialog: false,
      dialogTitle: '',
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 22,
      },
      apiName: '',
      search: {
        cityName: '',
        year: '',
        enterpriseName: '',
      },
      optionCity: cityJson,
      optionYear: [
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
      ],
      linkList: [
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
      ],
    };
  },
  computed: {
    tableCol() {
      let col = [];
      switch (this.apiName) {
        case 'getSpecialNewEnterpriseList':
        case 'getLitterEnterpriseList':
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'cityName',
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 320,
              align: 'left',
            },
          ];
          break;
        case 'getMapCityEnList':
          col = [
            {
              label: '排行',
              param: 'ranking',
              maxWidth: 70,
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 300,
              align: 'left',
            },
            {
              label: '所属行业',
              param: 'industry',
              width: 160,
              align: 'left',
            },
            {
              label: '营收（万元）',
              param: 'businessIncome',
              width: 80,
              align: 'left',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  watch: {
    mapCode(n) {
      console.log(n, '-mapCode-n');
    },
    isLogin(n) {
      if (n) {
        // let expiredTime = sessionStorage.getItem('expiredTime'),
        //   nowStamp = new Date().getTime(),
        //   lessHour = expiredTime - nowStamp < 1000 * 60 * 60;
        // // if (lessHour) {
        //   setTimeout(() => {
        //     console.log(expiredTime - nowStamp, new Date(), expiredTime, nowStamp, '-in-expiredTime - nowStamp')
        //     this.$message.warning('登录超时，请重新登录！');
        //     sessionStorage.removeItem('expiredTime');
        //     this.isLogin = false;
        //   }, expiredTime - nowStamp)
        // // }
      }
    },
    'search.enterpriseName'(n) {
      this.getData();
    },
  },
  mounted() {
    // this.timer =  setInterval(() => {
    //     this.currentTime = getTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
    //   }, 1000);
    this.busOn();
    this.setTimer();

    // let expiredTime = sessionStorage.getItem('expiredTime');
    // let nowStamp = new Date().getTime();
    // if (expiredTime && nowStamp < expiredTime) {
    //   this.isLogin = true;
    // }

    window.onresize = () => {
      this.resizeChart();
    };
  },
  methods: {
    handleLink(e) {
      console.log(e);
      this.linkParams = e;
    },
    clearSearch() {
      this.pager.pageSize = 10;
      this.pager.currentPage = 1;
      this.search = {
        enterpriseName: '',
        provinceName: '',
        cityName: '',
        year: '',
      };
    },
    busOn() {
      this.$bus.$on('showEn500Dialog', (data) => {
        this.dialogTitle =
          data.name + `${data.name.includes('省') || data.name.length > 2 ? '' : '市'}全国民营企业500强名单`;
        this.clearSearch();
        let params = {
          cityName: data.name,
          year: data.year,
        };
        if (data.type === 1) {
          delete params.cityName;
          params.provinceName = data.name;
        }
        this.search = {
          ...this.search,
          ...params,
        };
        this.getData('500强', params);
      });
    },
    handleClickChart(params, name) {
      console.log(params, name, 'pp');
      this.dialogTitle = `${params.name}年${name}${params.seriesName}名单`;
      this.clearSearch();
      this.search.year = params.name;
      this.getData(name, this.search);
      this.show = true;
    },
    changeVal(e, type) {
      this.search[type] = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.getData();
    },
    changeMapCode(e) {
      this.mapCode = e.code;
      this.mapName = e?.name;
      console.log(e, '-e');
    },
    submit() {
      if (this.pass) {
        if (this.pass !== 'sgsl2022') {
          this.$message.info('密码错误，请重新输入！');
        } else {
          this.isLogin = true;
          let expiredTime = new Date().getTime() + 1000 * 60 * 60 * 12;
          sessionStorage.setItem('expiredTime', expiredTime);
        }
      } else {
        this.$message.info('请输入密码！');
      }
    },
    setTimer() {
      this.timer1 = setInterval(() => {
        this.$nextTick(() => {
          let chartBox = [
            'PrivateEnterprise',
            'barHighTech',
            'barSpecialNew',
            'GDPAndGrowthRate',
            'FixedAssetInvestment',
            'EconomicVolume',
            'MarketSubjectType',
            'MarketMainIndustry',
            'barPrivateTax',
            'barBankFinance',
          ];
          let i = 0;
          chartBox.map((item) => {
            setTimeout(() => {
              // this.$refs[item].setInterData();
            }, i * 100);
            i++;
          });
        });
      }, 5000);
    },
    resizeChart() {
      let chartBox = [
        'PrivateEnterprise',
        'barHighTech',
        'barSpecialNew',
        'GDPAndGrowthRate',
        'FixedAssetInvestment',
        'EconomicVolume',
        'MarketSubjectType',
        'MarketMainIndustry',
        'barPrivateTax',
        'barBankFinance',
      ];
      chartBox.map((item) => {
        for (let key in this.$refs[item].$refs) {
          this.$refs[item].$refs[key].resize();
        }
      });
    },
    getData(name, params) {
      let apiName = this.apiName;
      !name ? (name = this.dialogTitle) : '';
      if (this.dialogTitle.includes('企业中小')) {
        apiName = 'getSpecialNewEnterpriseList';
      }
      if (this.dialogTitle.includes('企业小巨人')) {
        apiName = 'getLitterEnterpriseList';
      }
      if (this.dialogTitle.includes('500强')) {
        apiName = 'getMapCityEnList';
      }
      this.apiName = apiName;
      params = {
        ...params,
        ...this.search,
        pageSize: this.pager.pageSize,
        pageNum: this.pager.currentPage,
      };
      this.search = {
        ...params,
      };
      if (!apiName) return;
      this.$api.screen[apiName](params).then((res) => {
        let { data } = res.data;
        this.tableData = data.records;
        this.pager.total = data.total;
        this.showDialog = true;
        this.loading = false;
      });
    },
    toPolicy() {
      router.push('/policy');
    },
  },
  beforeDestroy() {
    this.$bus.$off('showEn500Dialog');
    // sessionStorage.removeItem('expiredTime');
    // clearInterval(this.timer)
    // clearSetInterval(this.timer1)
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: Digital;
  src: url('../../assets/unicode.digital.ttf');
}

.home {
  /*width: 100%;*/
  width: 3200px;
  height: 1080px;
  /*background: #08090e url('../../assets/home/header.gif') no-repeat;*/
  background: url('~img/home/home-bg.jpg') no-repeat;
  background-size: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  .left-bar,
  .right-bar {
    width: 24px;
    height: 899px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: url('~img/market/market-left-bar.png') center center no-repeat;
    background-size: 100%;
  }
  .right-bar {
    left: unset;
    right: 0;
    transform: translateY(-50%) rotateY(180deg);
  }
  .bottom-bar {
    height: 24px;
    width: 2441px;
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 999;
    transform: translateX(-50%);
    background: url('~img/market/market-bottom-bar.png') center center no-repeat;
    background-size: 100%;
  }

  .time {
    position: absolute;
    top: 50px;
    right: 30px;

    img {
      width: 10px;
      margin-right: 5px;
    }

    span {
      font-family: Digital;
      color: #a2d0f4;
      font-size: 12px;
    }
  }
}

.content {
  display: flex;
  justify-content: space-around;
  padding: 0 15px;
  /*margin-top: 90px;*/
  // margin-top: 20px;
  height: calc(100% - 96px);
  z-index: 11;

  .center {
    flex: 1;
    position: relative;
    z-index: 1;

    .link {
      position: absolute;
      left: 38px;
      top: 208px;
      font-size: 18px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      text-decoration: underline;
      color: #e9e3b6;
      line-height: 43px;
      font-weight: bold;
      text-shadow: 2px 3px 2px rgba(30, 40, 60, 0.8);
      z-index: 2;
      cursor: pointer;
    }
    .aMap {
      width: calc(100% - 64px);
      position: absolute;
      top: 0;
      left: 32px;
      /*top: 250px;*/
    }

    /*width: 59%;*/
    //  border:1px solid #333;
  }

  .left,
  .right {
    display: flex;
    // z-index: 2;
    flex-wrap: wrap;
    // width: 20%;
    // border:1px solid #333;

    > div:first-child {
      // margin-right: 30px;
    }
  }

  .left {
    // width: 31%;
    width: 1024px;
    padding-left: 32px;
  }

  .right {
    width: 1024px;
    padding-right: 32px;
    > div {
      width: 100%;
      height: calc(100% / 3);
    }
    .right-center {
      display: flex;
      > div {
        width: calc(50% - 13px);
        &:first-of-type {
          margin-right: 26px;
        }
        /deep/ .title {
          white-space: nowrap;
          width: 100%;
          #btn-link {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        /deep/ .flex-between {
          height: 52px;
        }
      }
    }
  }
}

/deep/.ele-dialog {
  .filter-box {
    margin-bottom: 20px;
    .flex-center();
    justify-content: flex-end;

    > div {
      margin-left: 20px;
    }
  }

  .com-table {
    height: calc(100% - 60px);
  }
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .flex-center();
  justify-content: center;

  .login-box {
    width: 620px;
    height: 220px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 0 4px 0 rgba(235, 235, 235, 0.2);
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    > span {
      color: #fff;
      font-size: 26px;
      text-align: left;
      line-height: 60px;
      margin-top: -10px;
    }
  }

  .password {
    width: 100%;
    .flex-center();
    margin-bottom: 20px;

    /deep/ .el-input {
      width: 85%;
      height: 56px;

      .el-input__inner {
        height: 100% !important;
      }

      .el-input__suffix {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .el-button {
      margin-left: 20px;
      width: 100px;
      height: 56px;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  /*filter: blur(10px);*/
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.o0 {
  opacity: 0;
  width: 100px;
  height: 100px;
  background: url('~img/commonImg/map_bg.jpg');
}
</style>
